export default "__VITE_ASSET__103a9740__"